import React from 'react';
import Modal from '@common/modal';
import PositionTextListItemVO from '@domain/vo/common/PositionTextListItemVO';
import PositionTextListItem from '@components/common/positionTextListItem';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';

import classnames from 'classnames/bind';
import styles from './positionChallengeModal.module.scss';
const cx = classnames.bind(styles);

interface PositionChallengeModalProps {
  positionDetail: PositionDetailVO;
  positions: PositionTextListItemVO[];
  visible: boolean;
  onClose: () => void;
}

const PositionChallengeModal = ({ positionDetail, positions, visible, onClose }: PositionChallengeModalProps) => {
  const {
    additionalInfo: { challenge },
  } = positionDetail;

  if (!challenge || !positions || positions.length === 0) return null;

  const positionCount = positions?.length ?? 0;
  const positionEls = positions?.map((positionChallenge, i) => {
    return (
      <li className={cx('listItem')} key={i}>
        <PositionTextListItem positionData={positionChallenge} />
      </li>
    );
  });

  return (
    <Modal visible={visible}>
      <div className={cx('positionCompanyLayer')}>
        <em className={cx('title')}>
          {challenge.challengeName}에서 채용중인 {positionCount}개의 포지션
        </em>

        <div className={cx('scrollArea')}>
          <div className={cx('scrollInner')}>
            <div className={cx('scrollWrap')}>
              <ul className={cx('positionCompanyList')}>{positionEls}</ul>
            </div>
          </div>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default PositionChallengeModal;
